import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <div className="footerPosition">
      <p >Cuet -2022, All Rights Reserved</p>
    </div>
  );
};

export default Footer;